var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20392_32651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 16.3792C14.0618 16.9652 12.9752 17.3319 11.8092 17.4094C10.6199 17.4885 9.37832 17.4883 8.19149 17.4094C7.78279 17.3822 7.33732 17.2847 6.95367 17.1267C6.5268 16.9509 6.31332 16.863 6.20486 16.8763C6.09638 16.8897 5.93899 17.0057 5.62422 17.2378C5.06922 17.6471 4.37005 17.9411 3.33318 17.9158C2.80887 17.9031 2.54672 17.8967 2.42936 17.6966C2.312 17.4965 2.45817 17.2195 2.7505 16.6655C3.15594 15.8972 3.41283 15.0176 3.02358 14.3128C2.35318 13.3062 1.78374 12.114 1.70052 10.8264C1.65582 10.1346 1.65582 9.41807 1.70052 8.72623C1.80135 7.16615 2.39841 5.70367 3.33366 4.58398",
    stroke: "#FF543E",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41699 2.93293C6.25508 2.48729 7.19427 2.2095 8.19149 2.14321C9.37833 2.06433 10.6199 2.06416 11.8092 2.14321C15.295 2.37493 18.0717 5.19097 18.3002 8.72623C18.3448 9.41807 18.3448 10.1346 18.3002 10.8264C18.2093 12.2316 17.7159 13.5232 16.9354 14.584",
    stroke: "#FF543E",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 2.5L18.3337 19.1667",
    stroke: "#FF543E",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20392_32651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.6fb7926a35eda89589860e8af82a89ea.svg";
export { ForwardRef as ReactComponent };